import Home from '@/pages/Home.vue'
import account_login from '@/pages/account/login.vue'
import history_alarm_charts from '@/pages/history_alarm/history_alarm_charts.vue'
import current_alarm_list from '@/pages/current_alarm/current_alarm_list.vue'
import bussiessGroup_list from '@/pages/system_setup/group_list.vue'
import userManagelist from '@/pages/system_setup/user_list.vue'
import projectlist from '@/pages/system_setup/project_list.vue'
import history_alarm_list from '@/pages/history_alarm/history_alarm_list.vue'
import alarm_push_manage from '@/pages/system_setup/alarm_push_manage.vue'
import assets_manage_ba from '@/pages/assets_manage/ba_list.vue'
import assets_manage_terminal from '@/pages/assets_manage/terminal_list.vue'
import assets_manage_fas from '@/pages/assets_manage/fas_list.vue'
import routine_data_list from '@/pages/routine_data/routine_data_list.vue'
import energy_meter_list from '@/pages/maintain_data/energy_meter_list'
import energy_meter_manage_list from '@/pages/maintain_data/energy_meter_manage_list'
import firedata_list from '@/pages/maintain_data/firedata_list.vue'

import acquire_manage_list from '@/pages/acquire_manage/acquire_manage_list.vue'
import acquire_data_list from '@/pages/acquire_data/acquire_data_list.vue'
import privacy_agreement_manage from '@/pages/system_setup/privacy_agreement_manage.vue'

// const apiBaseURL = 'https://120.36.137.130:8090';
const apiBaseURL = 'https://www.pam-commandcentre.com:8090';
//https://192.168.0.115:8090  //测试环境
//https://www.pam-commandcentre.com //生产环境
//https://120.36.137.130:8090 //测试环境外网
//http://zeta1303.f3322.net:8485 开发环境

const isDebug = true;

function getAccessToken (){
   let user = sessionStorage.getItem('user');
   if(user) return JSON.parse(user).accessToken
   else return '';
}

function getAccount (){
    let user = sessionStorage.getItem('user');
    if(user) return JSON.parse(user).account;
    else return '';
 }

 function getAccountId (){
    let user = sessionStorage.getItem('user');
    if(user) return JSON.parse(user).id;
    else return '';
 }

 function getCurrentUser (){
    let user = sessionStorage.getItem('user');
    if(user) return JSON.parse(user);
    else return '';
 }

const alarmType = {'fire':'火警','abnormal':'故障','isolation':'隔离','action':'动作','normal':'正常'};

const routerPathMap = {'home':Home,'currentAlarm':current_alarm_list,'historyAlarmCharts':history_alarm_charts,
                        'historyAlarmList':history_alarm_list,'groupManage':bussiessGroup_list,'projectManage':projectlist,
                        'userManage':userManagelist,'pushManage':alarm_push_manage,'BA':assets_manage_ba,'terminal':assets_manage_terminal,
                        'FAS':assets_manage_fas,'CGSJLB':routine_data_list,'NYTJB':energy_meter_list,'NYBGL':energy_meter_manage_list,
                        'XFSJJL':firedata_list,'CJBGL':acquire_manage_list,'CJBSJJL':acquire_data_list,'privacyAgreementManage':privacy_agreement_manage
                        
                       };
const routerIconMap = {'currentAlarm':'el-icon-warning','historyData':'fa fa-bar-chart','systemManage':'el-icon-setting','assetManage':'el-icon-menu',
                        'YWSJ':'el-icon-message','CGSJ':'el-icon-document'};

let permissionNodeList= {
'terminal_add':{name: "传感器新增", code: "terminal_add",hasEntitle:0},
'terminal_del':{name: "传感器删除", code: "terminal_del",hasEntitle:0},
'terminal_edit':{name: "传感器编辑", code: "terminal_edit",hasEntitle:0},
'terminal_export':{name: "传感器导出", code: "terminal_export",hasEntitle:0},
'terminal_import':{name: "传感器导入", code: "terminal_import",hasEntitle:0},
'terminal_show':{name: "传感器查看配置", code: "terminal_show",hasEntitle:0},
'terminal_conf':{name: "传感器配置", code: "terminal_conf",hasEntitle:0},
'terminal_shield':{name: "传感器屏蔽", code: "terminal_shield",hasEntitle:0},
'BA_add':{name: "BA点表新增", code: "BA_add",hasEntitle:0},
'BA_del':{name: "BA点表删除", code: "BA_del",hasEntitle:0},
'BA_edit':{name: "BA点表编辑", code: "BA_edit",hasEntitle:0},
'BA_export':{name: "BA点表导出", code: "BA_export",hasEntitle:0},
'BA_import':{name: "BA点表导入", code: "BA_import",hasEntitle:0},
'BA_show':{name: "BA点表查看配置", code: "BA_show",hasEntitle:0},
'BA_conf':{name: "BA点表配置", code: "BA_conf",hasEntitle:0},
'BA_shield':{name: "BA点表屏蔽", code: "BA_shield",hasEntitle:0},
'FAS_add':{name: "FAS点表新增", code: "FAS_add",hasEntitle:0},
'FAS_del':{name: "FAS点表删除", code: "FAS_del",hasEntitle:0},
'FAS_edit':{name: "FAS点表编辑", code: "FAS_edit",hasEntitle:0},
'FAS_export':{name: "FAS点表导出", code: "FAS_export",hasEntitle:0},
'FAS_import':{name: "FAS点表导入", code: "FAS_import",hasEntitle:0},
'NYBGL_add':{name: "电能表管理新增", code: "NYBGL_add",hasEntitle:0},
'NYBGL_del':{name: "电能表管理删除", code: "NYBGL_del",hasEntitle:0},
'NYBGL_edit':{name: "电能表管理编辑", code: "NYBGL_edit",hasEntitle:0},
'NYBGL_export':{name: "电能表管理导出", code: "NYBGL_export",hasEntitle:0},
'NYBGL_import':{name: "电能表管理导入", code: "NYBGL_import",hasEntitle:0},
'CJBGL_add':{name: "采集表管理新增", code: "CJBGL_add",hasEntitle:0},
'CJBGL_del':{name: "采集表管理删除", code: "CJBGL_del",hasEntitle:0},
'CJBGL_edit':{name: "采集表管理编辑", code: "CJBGL_edit",hasEntitle:0},
'CJBGL_export':{name: "采集表管理导出", code: "CJBGL_export",hasEntitle:0},
'CJBGL_import':{name: "采集表管理导入", code: "CJBGL_import",hasEntitle:0},
'CJBGL_config':{name: "采集表管理参数配置", code: "CJBGL_config",hasEntitle:0},
'CJBSJJL_export':{name: "采集表数据记录导出", code: "CJBSJJL_export",hasEntitle:0}

};

//多组配置设备列表 'YS-ZN-024','YS-ZN-025','YS-ZN-026','YS-ZN-004-10'
let multDeviceModelList= ['AIoT-VTD01','AIoT-VTD10']


function getInitialPermissionNodeList (){
   return permissionNodeList;
}

function getPermissionNodeList (){
   let globalPermissionNodeList = sessionStorage.getItem('globalPermissionNodeList');
    if(globalPermissionNodeList) return JSON.parse(globalPermissionNodeList);
    else return getInitialPermissionNodeList();
}

export default{
    apiBaseURL,
    getAccessToken,
    alarmType,
    isDebug,
    getAccount,
    routerPathMap,
    routerIconMap,
    getAccountId,
    getCurrentUser,
    getInitialPermissionNodeList,
    getPermissionNodeList,
    multDeviceModelList
}




// WEBPACK FOOTER //
// ./src/config/global_config.js